import { render, staticRenderFns } from "./AttachmentsTab.vue?vue&type=template&id=3ca75a31&scoped=true&"
import script from "./AttachmentsTab.vue?vue&type=script&lang=js&"
export * from "./AttachmentsTab.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsTab.vue?vue&type=style&index=0&id=3ca75a31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca75a31",
  null
  
)

export default component.exports